export default {
  BTC: [
    'Basketball',
    'Beach Volleyball',
    'Soccer',
    'Day & Night Tennis',
    'Croquet',
    'Shuffleboard',
    'Table Tennis',
    'Billiards',
    'Lawn Chess',
    'Pool Tables',
    'Board Games',
    'Fitness Center'
  ],
  BBO: [
    'Basketball',
    'Day & Night Tennis',
    'Table Tennis',
    'Board Games',
    'Croquet',
    'Lawn Chess',
    'Pool Tables',
    'Shuffleboard',
    'Golf',
    'Fitness Center'
  ],
  BNG: [
    'Basketball',
    'Beach Volleyball',
    'Day & Night Tennis',
    'Fitness Center',
    'Bocce Ball',
    'Croquet',
    'Lawn Chess',
    'Horseshoes',
    'Soccer',
    'Billiards',
    'Table Tennis',
    'Shuffleboard',
    'Board Games',
    'Cards'
  ]
};
